import { ProductTypes } from '../../../../../../../../types';
import { ModifierTypes } from './modifierTypes';

const REVERSE_IRPM_ON_EVERY_UW_FACTOR: readonly string[] = [
  ProductTypes.prime_one,
  ProductTypes.prime_one_au,
  ProductTypes.prime_one_tech,
];

const REVERSE_IRPM_ON_IRPM_ONLY: readonly string[] = [
  ProductTypes.prime_one_plus_us,
  ProductTypes.p250x,
  ProductTypes.prime_one_us,
  ProductTypes.prime_tech,
];

export const showsReverseIrpmCalculator = (
  productType: string | undefined,
  modifierId: string
): boolean =>
  REVERSE_IRPM_ON_EVERY_UW_FACTOR.includes(productType ?? '') ||
  (REVERSE_IRPM_ON_IRPM_ONLY.includes(productType ?? '') &&
    modifierId === ModifierTypes.IRPM);
